import {
  FETCH_KIOSK_SETTINGS,
  FETCH_KIOSK_USER,
  FETCH_KIOSK_JOBS,
  FETCH_KIOSK_MOMENTS,
  FETCH_KIOSK_SELECTED_JOB,
  FETCH_KIOSK_SELECTIONS,
  FETCH_KIOSK_EMAIL,
  FETCH_ROOM_MOMENTS,
  FETCH_GUESTS,
  FETCH_PORTAL_MOMENTS,
  SELECT_KIOSK_MOMENTS,
  UNSELECT_KIOSK_MOMENTS,
  VIEW_CATALOG,
  VIEW_GALLERY,
  VIEW_CART,
  VIEW_RECEIPT,
  KIOSK_LOADED,
  SET_CURRENT_DATE,
  SET_DATES,
  FETCH_FAMILY,
  FETCH_VISITS,
  FETCH_VISIT,
  REMOVE_VISIT,
  FETCH_MERGED_STORIES,
  ADD_MERGED_STORY,
  SET_SCROLL_POSITION,
  GET_KIOSK_PRINT_SIZES,
  SELECT_PRE_PRINTS,
  UNSELECT_PRE_PRINTS,
  CLEAR_PRE_PRINTS,
  GET_KNOCKOUT_ELEMENTS,
  SET_DEFAULT_KIOSK_READER,
  VIEW_VIDEO,
  VALIDATE_KNOCKOUT_ELEMENTS,
  CHECK_EXISTING_EDITS,
  SELECT_PRINT_SIZE_FOR_CROP,
  TIMEOUT_DIALOG_OPEN,
  FETCH_MOMENT_COUNT
} from 'app/actions/types';

import {
  LOGOUT,
  NEW_ORDER,
  SET_PURCHASED,
  REMOVE_CART_MOMENT,
  GET_KIOSK_PRICINGS
} from 'shared/actions/types';

import {
  CATALOG_SCREEN,
  GALLERY_SCREEN
} from 'app/utils/Constants';

import produce from 'immer';
import { VIEW_PRE_PRINT } from '../actions/types';
import { validateKnockoutElements } from '../actions/kioskActions';

const initialState = {
  loaded: false,
  settings: null,
  since: null,
  jobs: {
    allIds: [],
    byId: {}
  },
  moments: {
    allIds: [],
    byId: {}
  },
  jobMoments: {},
  user: null,
  selectedJobId: null,
  selectedMomentIds: [],
  view: VIEW_GALLERY,
  email: null,
  currentDate: null,
  dates: [],
  loggedIn: false,
  roomMoments: {
    byId: {},
    allIds: []
  },
  guests: [],
  visits: {
    byId: {},
    allIds: []
  },
  rooms: null,
  mergedStories: [],
  scrollPosition: 0,
  printSizes: [],
  selectedPrintSizes: [],
  kioskPricings: [],
  portalMoments: {
    byId: {},
    allIds: []
  },
  selectedPrintMomentIds: [],
  knockOutElements: {},
  showVideoDialog: false,
  videoMoment: null,
  validateKnockoutElements: {},
  hasPrintSizeEdits: false,
  selectedPrintSizeForCrop: null,
  timeOutDialogVisible: false,
  restorePhotoswipe: false,
  portalMomentCount: 0
}

const fetchResource = (resource, payload, draft, sort = true) => {
  if (Array.isArray(payload)) {
    payload.forEach(record => {
      draft[resource].byId[record.id] = record;
      draft[resource].allIds.push(record.id);
    });
  } else {
    draft[resource].byId[payload.id] = payload;
    draft[resource].allIds.push(payload.id);
  }

  draft[resource].allIds = draft[resource].allIds.filter((value, index, self) => {
    return self.indexOf(value) === index;
  })

  if (sort) {
    draft[resource].allIds.sort((a, b) => a - b);
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case KIOSK_LOADED:
      return produce(state, draft => {
        draft.loaded = true;
      });

    case FETCH_KIOSK_SETTINGS:
      return produce(state, draft => {
        draft.settings = action.payload;
      });

    case FETCH_KIOSK_USER:
      return produce(state, draft => {
        let { user, isViewPhotos } = action.payload;

        draft.loggedIn = true;
        draft.user = user;
        draft.email = user.email;

        if (isViewPhotos) {
          draft.view = VIEW_PRE_PRINT;
        } else {
          if (user.purchased && state.settings.hide_buy_more === false) {
            draft.view = VIEW_RECEIPT;
          } else {
            switch (state.settings.start_screen) {
              case CATALOG_SCREEN:
                draft.view = VIEW_CATALOG;
                break;
              case GALLERY_SCREEN:
                draft.view = VIEW_GALLERY;
            }
          }
        }
      });

    case FETCH_KIOSK_JOBS:
      return produce(state, draft => fetchResource('jobs', action.payload, draft));

    case FETCH_KIOSK_SELECTED_JOB:
      return produce(state, draft => {
        draft.selectedJobId = action.payload;
      });

    case FETCH_KIOSK_MOMENTS:
      return produce(state, draft => {
        fetchResource('moments', action.payload.moments, draft);

        let jobId = action.payload.jobId;
        let momentIds = action.payload.moments.map(m => m.id);
        let prevCache = draft.jobMoments[jobId] || [];

        draft.jobMoments[jobId] = prevCache.concat(momentIds)
          .filter((value, index, self) => self.indexOf(value) === index);
      });

    case FETCH_ROOM_MOMENTS:
      return produce(state, draft => {
        fetchResource('roomMoments', action.payload, draft);
      });

    case FETCH_KIOSK_EMAIL:
      return produce(state, draft => {
        draft.email = action.payload;
      });

    case FETCH_KIOSK_SELECTIONS:
    case SELECT_KIOSK_MOMENTS:
      return produce(state, draft => {
        action.payload.forEach(momentId => {
          if (draft.selectedMomentIds.indexOf(momentId) === -1) {
            draft.selectedMomentIds.push(momentId);
          }
        });
      });

    case UNSELECT_KIOSK_MOMENTS:
      return produce(state, draft => {
        draft.selectedMomentIds = draft.selectedMomentIds.filter(momentId => {
          return action.payload.indexOf(momentId) === -1;
        });
      });

    case SET_CURRENT_DATE:
      return produce(state, draft => {
        draft.currentDate = action.payload;
      });

    case SET_DATES:
      return produce(state, draft => {
        draft.dates = action.payload;
      });

    case FETCH_GUESTS:
      return produce(state, draft => {
        draft.guests = action.payload;
      });

    case SET_PURCHASED:
      return produce(state, draft => {
        draft.user.purchased = true;

        let momentIds = action.payload;
        if (momentIds) {
          draft.selectedMomentIds = draft.selectedMomentIds.filter(id => momentIds.indexOf(id) === -1);
        }
      });

    case LOGOUT:
      return produce(state, draft => {
        draft.user = null;
        draft.roomMoments.byId = {};
        draft.roomMoments.allIds = [];
        draft.selectedJobId = null;
        draft.selectedMomentIds = [];
        draft.email = null;
        draft.view = VIEW_CATALOG;
        draft.currentDate = null;
        draft.dates = [];
        draft.guests = [];
        draft.visits.byId = {};
        draft.visits.allIds = [];
        draft.rooms = null;
        draft.mergedStories = [];
        draft.loggedIn = false;
      });

    case VIEW_CATALOG:
      return produce(state, draft => {
        draft.view = VIEW_CATALOG;
      });

    case VIEW_GALLERY:
      return produce(state, draft => {
        draft.view = VIEW_GALLERY;
      });

    case VIEW_CART:
      return produce(state, draft => {
        draft.view = VIEW_CART;
      });

    case VIEW_PRE_PRINT:
      return produce(state, draft => {
        draft.view = VIEW_PRE_PRINT;
      });

    case VIEW_RECEIPT:
      return produce(state, draft => {
        draft.view = VIEW_RECEIPT;
      });

    case NEW_ORDER:
      return produce(state, draft => {
        switch (state.settings.start_screen) {
          case CATALOG_SCREEN:
            draft.view = VIEW_CATALOG;
            break;

          case GALLERY_SCREEN:
            draft.view = VIEW_GALLERY;
        }

        draft.selectedJobId = null;
      });

    case REMOVE_CART_MOMENT:
      return produce(state, draft => {
        draft.selectedMomentIds = draft.selectedMomentIds.filter(id => {
          return id !== action.payload;
        });
      });

    case FETCH_FAMILY:
      return produce(state, draft => {
        if (draft.user) {
          draft.user.family_id = action.payload.id;
          draft.user.family_story_id = action.payload.story_id;
        }
      });

    case FETCH_VISITS:
      return produce(state, draft => {
        let visits = action.payload;

        for (let visit of visits) {
          if (draft.visits.allIds.indexOf(visit.id) === -1) {
            draft.visits.allIds.push(visit.id);
          }

          draft.visits.byId[visit.id] = visit;
        }

        draft.visits.allIds = draft.visits.allIds.sort((a, b) => {
          if (draft.visits.byId[a].room < draft.visits.byId[b].room) {
            return -1;
          } else {
            return 1;
          }
        });

        draft.rooms = draft.visits.allIds.map(id => {
          return draft.visits.byId[id].room;
        })
          .join(', ');
      });

    case FETCH_VISIT:
      return produce(state, draft => {
        let visit = action.payload;

        if (draft.visits.allIds.indexOf(visit.id) === -1) {
          draft.visits.allIds.push(visit.id);
        }

        draft.visits.byId[visit.id] = visit;

        draft.visits.allIds = draft.visits.allIds.sort((a, b) => {
          if (draft.visits.byId[a].room < draft.visits.byId[b].room) {
            return -1;
          } else {
            return 1;
          }
        });

        draft.rooms = draft.visits.allIds.map(id => {
          return draft.visits.byId[id].room;
        })
          .join(', ');
      });

    case REMOVE_VISIT:
      return produce(state, draft => {
        let visit = action.payload;

        draft.visits.allIds = draft.visits.allIds.filter(id => {
          return id !== visit.id;
        });

        draft.visits.byId[visit.id] = null;

        draft.rooms = draft.visits.allIds.map(id => {
          return draft.visits.byId[id].room;
        })
          .join(', ');
      });

    case FETCH_MERGED_STORIES:
      return produce(state, draft => {
        draft.mergedStories = action.payload;
      });

    case ADD_MERGED_STORY:
      return produce(state, draft => {
        let mergedStory = action.payload;
        // Check if the mergedStory exists
        let index = draft.mergedStories.findIndex(story => story.id == mergedStory.id);
        if (index == -1) {
          draft.mergedStories.push(mergedStory);
        } else {
          draft.mergedStories[index] = mergedStory;
        }
      });

    case SET_SCROLL_POSITION:
      return produce(state, draft => {
        draft.scrollPosition = action.payload;
      });

    case GET_KIOSK_PRINT_SIZES:
      return produce(state, draft => {
        draft.printSizes = action.payload;
      });

    case GET_KIOSK_PRICINGS:
      return produce(state, draft => {
        draft.kioskPricings = action.payload;
      });

    case FETCH_PORTAL_MOMENTS:
      return produce(state, draft => {
        draft.portalMoments.byId = {};
        draft.portalMoments.allIds = [];

        // action.payload.forEach(record => {
        //   draft.portalMoments.byId[record.id] = record;
        //   draft.portalMoments.allIds.push(record.id);
        // });

        fetchResource('portalMoments', action.payload, draft, false);
      });

    case SELECT_PRE_PRINTS:
      return produce(state, draft => {
        action.payload.forEach(momentId => {
          draft.selectedPrintMomentIds.push(momentId);
        });
      });

    case UNSELECT_PRE_PRINTS:
      return produce(state, draft => {
        let momentIds = action.payload;
        for (let momentId of momentIds) {
          let index = draft.selectedPrintMomentIds.indexOf(momentId);
          if (index > -1) {
            draft.selectedPrintMomentIds.splice(index, 1);
          }
        }
      })

    case CLEAR_PRE_PRINTS:
      return produce(state, draft => {
        draft.selectedPrintMomentIds = [];
      })

    case GET_KNOCKOUT_ELEMENTS:
      return produce(state, draft => {
        draft.knockOutElements = action.payload;
      })

    case SET_DEFAULT_KIOSK_READER:
      return produce(state, draft => {
        draft.defaultStripeReader = action.payload;
      })

    case VIEW_VIDEO:
      return produce(state, draft => {
        draft.showVideoDialog = action.payload.visible;
        draft.videoMoment = action.payload.videoMoment;
      })

    case VALIDATE_KNOCKOUT_ELEMENTS:
      return produce(state, draft => {
        draft.knockOutElements = action.payload;
      })

    case CHECK_EXISTING_EDITS:
      return produce(state, draft => {
        draft.hasPrintSizeEdits = action.payload;
      })

    case SELECT_PRINT_SIZE_FOR_CROP:
      return produce(state, draft => {
        draft.selectedPrintSizeForCrop = action.payload;
      })

    case TIMEOUT_DIALOG_OPEN:
      return produce(state, draft => {
        draft.timeOutDialogVisible = action.payload;
      })

    case FETCH_MOMENT_COUNT:
      return produce(state, draft => {
        draft.portalMomentCount = action.payload;
      })

    default:
      return state;
  }
}
